// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-container {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}
.btn-container .appic-btn {
  min-width: 150px;
}
.btn-container .btn-cont {
  display: flex;
  gap: 15px;
}

.form-row {
  display: flex;
  flex-wrap: nowrap;
  margin-right: -5px;
  margin-left: -5px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.form-row .img-preview-cont {
  max-width: 200px;
  padding: 20px;
  margin-right: 10px;
  max-height: 200px;
}
.form-row .img-preview-cont img {
  width: 100%;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
